module.exports = __webpack_public_path__ + "img/Componente 33 – 1.a1fb4477.svg";